import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { catchError, finalize, of, tap } from 'rxjs';
import {
  BrandSetting,
  DEFAULT_BRANDING,
} from '@app/brand-settings/brand-setting-service/brand-setting';
import { API_BASE_URL } from '@providers/api-config/api-config.token';
import { OrderSignerResponse } from '@shared/types/order-signer-response.interface';
import { ApproverStepsService } from '@app/approver-steps/services/approver-steps.service';
import { createLoadingAndClearAnimationHandler } from '@app/providers/order-data/loading-animation-handler/loading-animation.handler';
import { ERROR_ROUTE } from '@shared/types/error-route.const';
import { SigningErrorPagePath } from '@app/shared/types/signing-error-page-path.enum';

export const approverDataResolver: ResolveFn<OrderSignerResponse | RedirectCommand> = () => {
  const http = inject(HttpClient);
  const router = inject(Router);
  const apiBaseUrl = inject(API_BASE_URL);
  const brandSetting = inject(BrandSetting);
  const approverStepsService = inject(ApproverStepsService);
  const cleanUpAnimation = createLoadingAndClearAnimationHandler();

  return http.post<OrderSignerResponse>(`${apiBaseUrl}/api/approver/environment`, {}).pipe(
    tap((response) => {
      brandSetting.setBrandConfig(response.brandingResponse);
      brandSetting.applyBrandColors();
      approverStepsService.setStepsFromBackend(response.steps);
    }),
    catchError(() => {
      brandSetting.setBrandConfig(DEFAULT_BRANDING);
      brandSetting.applyBrandColors();
      return of(
        new RedirectCommand(router.parseUrl(`${ERROR_ROUTE}/${SigningErrorPagePath.Unexpected}`))
      );
    }),
    finalize(() => cleanUpAnimation())
  );
};
